import React from 'react';
import { SimpleTableHead, SimpleTableRow } from 'cdk-radial';
import { StickySimpleTableHeader } from '../../common/StyledComponents';

export default function ShippingDetailsTableHeaders(props: any): JSX.Element {
  return (
    <SimpleTableHead>
      <SimpleTableRow>
        <StickySimpleTableHeader colSpan="2" textAlign="left" style={{paddingBottom: "14px"}}>
          PO Number
        </StickySimpleTableHeader>
        <StickySimpleTableHeader colSpan="3" textAlign="center">
          Manual PO Number
        </StickySimpleTableHeader>

        <StickySimpleTableHeader colSpan="3" textAlign="center">
          DTNA Order Type
        </StickySimpleTableHeader>

        <StickySimpleTableHeader colSpan="3" textAlign="center">
          Shipping Preference
        </StickySimpleTableHeader>
        <StickySimpleTableHeader colSpan="4" textAlign="center">
          Shipping Notes (35 characters max)
        </StickySimpleTableHeader>
      </SimpleTableRow>
    </SimpleTableHead>
  );
}
